import {
    AbstractPmsApiService
} from "./abstract.service";
import {
    EmailTemplate
} from "../models";

export class TemplatePmsApiService extends AbstractPmsApiService {


    get urlPattern() {

        return `/property/:propertyId/${this.templateType}(/:id)(/:option)`;
    }

    static get templateType(){

        throw new Error("Describe template type in derived class!");
    }

    get(params = {}, property = null) {

        const url = this.url({
            propertyId: property.id
        });

        return this.http.get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    create(template, property) {

        const url = this.url({
            propertyId: property.id
        });

        return this.http
            .post(url, template.toObjectExcept('property'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    update(template) {

        const url = this.url({
            propertyId: template.property.id,
            id: template.id
        });

        return this.http
            .put(url, template.toObjectExcept('property'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    delete(template) {

        const url = this.url({
            propertyId: template.property.id,
            id: template.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/template.service.js